import { InputLabel, MenuItem, SelectChangeEvent } from '@mui/material';
import { memo } from 'react';
import { __TOPONYMY_API_URL__ } from 'shell/constants/environment';
import { ItemVM } from 'shell/view-models/item';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { HttpResponseList } from 'shell/models/http-response';
import { PmiFormControl } from '../pmi-select/pmi-form-control';
import { PmiSelect } from '../pmi-select';

interface KindStreetListComponentProps {
  disabled?: boolean;
  value: string;
  onChange?: (event: SelectChangeEvent<string>) => void;
  onChangeItem?: (value: ItemVM | undefined) => void;
  error?: boolean;
  label?: string;
  id?: string;
  onBootstrap?: boolean;
  required?: boolean;
}

const KindStreetListComponent = ({
  disabled,
  onChange,
  onChangeItem,
  value,
  error,
  label = 'Specie',
  required,
  id = 'kind-street',
  onBootstrap = true,
}: KindStreetListComponentProps): React.ReactElement => {
  const [kindStreetList] = useHttpFetch<HttpResponseList<string>, Array<ItemVM>>(
    `${__TOPONYMY_API_URL__}/areaCircolazione/tipo-area`,
    {
      options: {
        method: 'GET',
        abortable: true,
        errorCatching: false,
        loading: false,
      },
      onBootstrap,
      transformer: (response) => {
        return response.data.payload?.list.map((item) => ({
          id: item,
          value: item,
        }));
      },
    }
  );

  return (
    <PmiFormControl fullWidth>
      <InputLabel error={error} disabled={disabled} id={`${id}-label`}>
        {required ? `${label} *` : `${label}`}
      </InputLabel>
      <PmiSelect
        labelId={`${id}-label`}
        id={id}
        name={id}
        value={value}
        label={required ? `${label} *` : `${label}`}
        onChange={(event) => {
          const selectedValue = event.target.value;
          if (onChangeItem) {
            const foundElement = (kindStreetList?.data as Array<ItemVM>).find(
              (item) => item.id === selectedValue
            );
            onChangeItem(foundElement);
            return;
          }
          if (onChange) {
            onChange(event);
          }
        }}
        disabled={disabled}
        error={error}
      >
        <MenuItem value="">
          <em>Nessuno</em>
        </MenuItem>
        {kindStreetList?.data
          ? (kindStreetList?.data as Array<ItemVM>).map((item: ItemVM) => (
              <MenuItem key={item.id} value={item.id}>
                {item.value}
              </MenuItem>
            ))
          : undefined}
      </PmiSelect>
    </PmiFormControl>
  );
};

KindStreetListComponent.displayName = 'Kind street list component';

const KindStreetList = memo(KindStreetListComponent);

export default KindStreetList as typeof KindStreetListComponent;
